<template>
	<v-dialog
		v-model="dialogOpen"
		max-width="700px"
	>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
		<v-card>
			<v-card-title>
				<translate>
					New A/B Test
				</translate>
			</v-card-title>
			<v-card-text>
				<v-container>
					<v-row>
						<v-col>
							<v-timeline
								density="compact"
							>
								<v-timeline-item
									v-for="(productVersion, index) in selected.concat(selected)"
									:key="productVersion"
									dot-color="primary"
								>
									<v-row
										class="pt-2"
									>
										<v-col>
											<b>
												{{ dateString(index * recurring) }}
											</b>
											- Version {{ productVersion }}
										</v-col>
									</v-row>
								</v-timeline-item>
							</v-timeline>
						</v-col>
						<v-col
							cols="6"
							align-self="center"
						>
							<v-row>
								<v-col>
									<v-checkbox
										v-for="productVersion in productVersions"
										:key="productVersion.id"
										v-model="selected"
										density="compact"
										:label="`Version ${productVersion.id}`"
										:value="productVersion.id"
										color="primary"
									/>
								</v-col>
							</v-row>
							<recurring-select
								v-model="recurring"
							/>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="primary"
					@click="startTest"
				>
					<translate>
						Activate
					</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import RecurringSelect from './RecurringSelect.vue';

export default {
	name: 'ABTestSetup',
	components: {
		RecurringSelect
	},

	props: {
		productId: {
			type: Number,
			required: true
		},
	},

	emits: [ 'new-test', ],

	data () {
		return {
			dialogOpen: false,
			loading: false,
			recurring: 1,
			productVersions: [],
			selected: []
		};
	},

	async created () {
		await this.getProductVersions();
		this.productVersions.forEach((productVersion) => {
			this.selected.push(productVersion.id);
		});
	},

	methods: {
		/**
		 * @param {Date} from
		 * @param {Date} to
		 *
		 * @returns {boolean}
		 */
		isActive (from, to) {
			const fromDate = new Date(from);
			const toDate = new Date(to);
			const today = new Date();

			return fromDate < today && today < toDate;
		},

		/**
		 * @param {number} offset
		 * @returns {string}
		 */
		dateString (offset) {
			const date = new Date();

			date.setDate(date.getDate() + offset);
			return date.toLocaleDateString();
		},

		/**
		 * Start a new abtest on selected product version
		 */
		startTest () {
			axios.post('/api/v0/abtests', {
				productVersions: this.selected,
				productId: this.productId,
				swapFrequency: this.recurring,
				startDate: new Date().toLocaleDateString(),
				endDate: new Date('2099-12-12').toLocaleDateString(),
			}).then(() => {
				this.$emit('new-test');
				this.dialogOpen = false;
			});
		},

		/**
		 * Get product versions from API
		 */
		async getProductVersions () {
			await axios.get(`/api/v0/productversions?product_id=${this.productId}`).then(({
				data
			}) => {
				this.productVersions = data.filter((version) => this.isActive(version.validfrom, version.validuntil));
			});
		}
	}
};
</script>

<style scoped>

</style>
